import { useFormik } from "formik";
import {
	ForgotPasswordFormValues,
	ForgotPasswordSchema,
	toast,
	ForgotPassword as View,
} from "ui-components";

import { usePageLoaded } from "~auth/hooks/usePageLoaded";
import { useSendUpdatePasswordEmail } from "~auth/queries/useSendUpdatePasswordEmail";

export const ForgotPassword = () => {
	const isPageLoaded = usePageLoaded();
	const sendEmail = useSendUpdatePasswordEmail();
	const form = useFormik<ForgotPasswordFormValues>({
		validateOnMount: true,
		initialValues: {
			email: "",
		},
		validationSchema: ForgotPasswordSchema,
		onSubmit: (values, helpers) => {
			toast.promise(
				async () => {
					await sendEmail.mutateAsync(values).catch(console.error);
					helpers.setSubmitting(false);
				},
				{
					loading: "Sending reset link...",
					success:
						"If the email is linked to an account, reset instructions will be sent shortly.",
					error: (e) => e.message ?? "Something went wrong!",
				},
			);
		},
	});

	if (!isPageLoaded) return null;

	return <View form={form} />;
};
